import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {Diskusia} from '../model/diskusia';
import {AisCommonModule} from 'ais-common';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {DatePipe, JsonPipe, NgForOf, NgIf} from '@angular/common';
import {Prispevok} from '../model/Prispevok';
import {MatIcon} from '@angular/material/icon';
import {FormsModule} from '@angular/forms';
import {MatSuffix} from '@angular/material/form-field';
import {MatMenuModule, MatMenuTrigger} from '@angular/material/menu';
import {PodporaPrispevokComponent} from '../podpora-prispevok/podpora-prispevok.component';
import {CommonModule} from '@angular/common';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'app-podpora-detail',
    imports: [
        MatDialogActions,
        MatDialogContent,
        MatProgressSpinner,
        NgIf,
        NgForOf,
        MatIcon,
        AisCommonModule,
        FormsModule,
        MatIconButton,
        MatSuffix,
        MatMenuModule,
        PodporaPrispevokComponent,
        CommonModule
    ],
    templateUrl: './podpora-detail.component.html',
    styleUrl: './podpora-detail.component.css'
})
export class PodporaDetailComponent implements OnInit, AfterViewInit
{
    diskusia: Diskusia;
    prispevky: Prispevok[];
    loading = true;
    value = null;
    display = 'large';

    @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

    // @ViewChild('spodnaCastDiskusie') spodnaCastRef!: ElementRef;
    @ViewChild('spodnaCast') spodnaCastRef!: ElementRef;

  constructor(
      public dialogRef: MatDialogRef<PodporaDetailComponent>,
      private http: HttpClient,
      @Inject(MAT_DIALOG_DATA) public data: {diskusia: Diskusia, display: string},
      private appService: AppService,
      private translate: TranslateService
    ) { }

    ngOnInit(): void
    {
        this.diskusia = this.data.diskusia;

        this.display = this.data.display ? this.data.display : 'large';

        this.nacitajPrispevky();
    }

    ngAfterViewInit() {
      //chceme nastavit scrollbar na koniec diskusie (tam su najnovsie prispevky).
      // pouzijeme event listener, ktory caka na vykreslenie komponentu, lebo inak to nechcelo fungovat:
      const observer = new MutationObserver(() => {
        const bottomElement = document.getElementById('spodnaCastDiskusie');
        if (bottomElement) {
          bottomElement.scrollIntoView({ behavior: 'instant' });
          observer.disconnect(); // Ukončenie pozorovania
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    sendMessage(value: string, anonym: boolean = false)
    {
      this.loading = true;

      if (anonym && this.diskusia.riadena) {
        this.appService.openOkDialog(this.translate.instant('anonym_theme_info'));
      }

      this.http.post('/ais/rest/portal/prispevok-new/' + this.diskusia.id, {text: value, autor: anonym ? 'nouser' : 'user'})
        .subscribe({
            next: () => {
                this.value = '';
                this.nacitajPrispevky();

                // timeout je tu kvoli tomu, aby sa stihol nacitat cely obsah diskusie
                setTimeout(() => {
                  const bottomElement = document.getElementById('spodnaCastDiskusie');
                  if (bottomElement) {
                    bottomElement.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 500);
                //alternativa
                // const element = this.dialogContent.nativeElement;
                // if (element) {
                //   element.lastElementChild.scrollIntoView({ behavior: 'smooth'});
                // }

            },
            error: (err) => {
                console.error(err);
            }
        });
    }

    nacitajPrispevky(): void
    {
        this.loading = true;

        this.http.get('/ais/rest/portal/prispevky/' + this.diskusia.id)
          .subscribe({
              next: (data: Prispevok[]) => {
                  this.prispevky = data;
                  this.loading = false;
                  setTimeout(() => {
                    if (this.scrollContainer && this.scrollContainer.nativeElement) {
                      this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
                    }
                  }, 1000);
              },
              error: (err) => {
                  console.error(err);
              }
          });
    }

}
